export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20wide%20composition%20with%20warm%20theater%20curtain%20textures%2C%20soft%20golden%20and%20coral%20gradients%2C%20abstract%20film%20reel%20and%20light%20beam%20elements%2C%20dark%20rich%20background%20with%20elegant%20atmosphere%2C%20movie%20premiere%20aesthetic%2C%20professional%20cinematic%20style%2C%20horizontal%20panoramic%20composition&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="色影视在线观影平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
            <div className="flex-1 text-center lg:text-left pt-20 md:pt-24 pb-6 lg:pb-24">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
                <i className="ri-fire-line text-accent-400 text-sm"></i>
                <span className="text-xs font-medium text-accent-300 whitespace-nowrap">2026暑期档 · 热播不间断</span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight">
                色影视 · 不缓冲追剧<br />
                <span className="text-accent-400">高清流畅每一帧</span>
              </h1>

              <p className="text-sm md:text-base text-background-100/80 mt-5 max-w-xl leading-relaxed">
                色影视是新一代在线影视观看平台，汇聚电视剧全集、电影完整版和综艺节目，依托自研P2P-CDN混合加速技术，实现真正不缓冲追剧体验。
                每日更新最新剧集，涵盖古装、悬疑、都市、科幻等全品类内容，无论热播大剧还是冷门佳作，高清画质流畅播放一站满足。
              </p>

              <div className="flex flex-wrap items-center gap-6 mt-6 justify-center lg:justify-start">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                    <i className="ri-movie-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-100/70 whitespace-nowrap">15000+ 影视资源</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                    <i className="ri-speed-up-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-100/70 whitespace-nowrap">99.7% 流畅播放</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-secondary-500/20 flex items-center justify-center">
                    <i className="ri-timer-line text-secondary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-100/70 whitespace-nowrap">剧集更新 &lt; 4小时</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
                <a
                  href="#cards"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始追剧
                </a>
                <a
                  href="#index"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-100/30 hover:border-background-100/60 text-background-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-compass-3-line text-lg"></i>
                  浏览片库
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none pb-8 lg:pb-24">
              <div className="relative rounded-2xl overflow-hidden bg-background-950/40 border border-background-100/10">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20striking%20cinematic%20poster%20composition%20showing%20a%20dramatic%20blend%20of%20Chinese%20historical%20drama%20and%20modern%20sci-fi%20elements%2C%20warm%20golden%20and%20coral%20gradients%2C%20film%20grain%20texture%2C%20theatrical%20lighting%2C%20professional%20movie%20promotional%20style%2C%20elegant%20and%20powerful%20mood%2C%20vertical%20portrait%20orientation&width=700&height=900&seq=hero-visual-2026&orientation=portrait"
                  alt="色影视热门剧集视觉"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                  <p className="text-xs text-background-100/60 mb-1">正在热播</p>
                  <p className="text-base font-bold text-background-50 font-heading">庆余年 · 第二季</p>
                  <p className="text-xs text-background-100/60 mt-1">全46集 · 评分 9.5</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}